export default __webpack_public_path__ + "static/media/admin_delete.18d4b87d.svg";